import { BackendResponseDTO } from "@dto/backendResponse.dto";
import { PresetStatusColorType } from "antd/es/_util/colors";
import axios, { AxiosError } from "axios";
import dayjs from "dayjs";
import { RefObject } from "react";
import { useAppGlobStore } from "src/appGlobalStore";
import { API_URL } from "src/data/Api";
import { Const } from "src/data/Const";
import { GLOB } from "src/util/Glob";
import { Log } from "./log.service";

export class DataService {
  //TODO: preload classes, hwtypes...

  /**
   * Checks if backend is on different version than UI, reloads page if so, updates app info
   * @returns 'reload' if reloading, 'error' on fail, undefined otherwise
   */
  static checkVersionReload(): Promise<'reload' | 'error'> {
    const preVer = useAppGlobStore.getState().info?.backend?.version;
    GLOB.infoLoaded.reset();
    return axios.get<BackendResponseDTO>(API_URL.INFO).then((response) => {
      const dto = response.data.data;
      useAppGlobStore.setState({ info: dto });
      GLOB.instanceLabel = dto.backend.instance_label ?? '';
      GLOB.updateTitle();
      GLOB.infoLoaded.resolve();
      if (preVer && dto.backend.version !== preVer) {
        if (GLOB.showReleaseInfo)
          sessionStorage.setItem(GLOB.SHOW_RELEASE_INFO_KEY, 'true');
        DataService.reloadUI();
        return 'reload';
      }
    }, (reason: AxiosError) => {
      Log.error('Failed to get app info!', reason);
      GLOB.infoLoaded.reject(reason);
      return 'error';
    });
  }

  static reloadUI() {
    Log.warn('You are on different version of XorMon, reloading...');
    setTimeout(() => {
      window.location.reload();
    }, 500);
  }

  /**
   * Reloads left menu and clears loaded keys
   */
  static reloadLeftMenu: () => void;

  /**
   * Timeout for {@linkcode DataService.invokeOnSharedInterval}
   */
  static readonly sharedTimeout: RefObject<number> = { current: 0 };

  private static readonly sharedCallbacks = new Set<() => void>();

  /**
   * Invokes callback after each interval
   * @param callback function
   * @param interval timeout in ms, default {@link Const.TIMEOUT_SHORT}
   * @returns function to unregister the callback, stops the timer when no callback remains
   */
  static invokeOnSharedInterval(callback: () => void, interval = Const.TIMEOUT_SHORT) {
    DataService.sharedCallbacks.add(callback);
    if (!DataService.sharedTimeout.current) {
      const tick = () => {
        DataService.sharedTimeout.current = window.setTimeout(() => {
          DataService.sharedCallbacks.forEach(cb => cb());
          tick();
        }, interval);
      };
      tick();
    }
    return () => {
      DataService.sharedCallbacks.delete(callback);
      if (!DataService.sharedCallbacks.size) {
        window.clearTimeout(DataService.sharedTimeout.current);
        DataService.sharedTimeout.current = 0;
      }
    };
  }

  static detectLicenseColor(): PresetStatusColorType {
    const techno = useAppGlobStore.getState().info?.backend?.premium?.technologies;
    if (!techno?.length) return 'default';

    const dates = techno?.map(lt => dayjs(lt.expirationDate));
    const oldest = dates.reduce((prev, cur) => cur.isBefore(prev) ? cur : prev);
    const now = dayjs();

    if (oldest.isBefore(now)) return 'error';
    if (oldest.diff(now, 'M') < 2) return 'warning';
    return 'default';
  }

  // constructor(){
  //   this.ws.onopen = () => setIsConnected(true);
  //   this.ws.onclose = (event) => {
  //     // TODO: to use this, it is necessary to sync BE&FE usage of WS
  //     // if (!event.wasClean && event.reason)
  //     //   Log.error(`Close of WebSocket '${url}' was unexpected.`, event.reason);

  //     setIsConnected(false);
  //   }
  //   this.ws.onmessage = (event) => setData(JSON.parse(event.data));
  // }

}